import React from 'react';
import { DIMENSIONS } from '../../constants/gameConstants';

const CountdownScreen = ({ countdown, activeDimensions, nValue }) => {
  return (
    <div style={{
      maxWidth: '800px',
      margin: '0 auto',
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '2rem'
    }}>
      <div style={{
        textAlign: 'center',
        animation: 'pulse 0.5s ease-in-out'
      }}>
        <div style={{
          fontSize: '12rem',
          fontWeight: '900',
          background: 'linear-gradient(135deg, #60a5fa 0%, #a78bfa 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          marginBottom: '0.5rem',
          animation: 'scaleIn 0.3s ease-out',
          lineHeight: '1'
        }}>
          {countdown}
        </div>
        <div style={{
          fontSize: '1.5rem',
          color: '#94a3b8',
          fontWeight: '600',
          marginBottom: '0.5rem'
        }}>
          Get Ready...
        </div>
        <div style={{
          fontSize: '1.5rem',
          color: '#60a5fa',
          fontWeight: '700'
        }}>
          {nValue}-Back
        </div>
      </div>
      
      {/* Keyboard shortcuts during countdown */}
      <div style={{
        background: 'rgba(30, 41, 59, 0.6)',
        backdropFilter: 'blur(20px)',
        borderRadius: '16px',
        padding: '1.5rem 2rem',
        border: '1px solid rgba(100, 116, 139, 0.3)',
        maxWidth: '600px'
      }}>
        <div style={{
          fontSize: '1rem',
          color: '#94a3b8',
          fontWeight: '600',
          marginBottom: '1rem',
          textAlign: 'center'
        }}>
          Press these keys when you detect a match:
        </div>
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '1rem',
          justifyContent: 'center'
        }}>
          {activeDimensions.map(dim => (
            <div key={dim} style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '0.5rem'
            }}>
              <kbd style={{
                background: DIMENSIONS[dim].color,
                color: 'white',
                padding: '0.75rem 1.25rem',
                borderRadius: '8px',
                fontWeight: '700',
                fontSize: '1.5rem',
                minWidth: '3rem',
                textAlign: 'center',
                boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                border: '2px solid rgba(255,255,255,0.2)'
              }}>
                {DIMENSIONS[dim].key.toUpperCase()}
              </kbd>
              <span style={{
                color: '#cbd5e1',
                fontSize: '0.9rem',
                fontWeight: '500'
              }}>
                {DIMENSIONS[dim].name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CountdownScreen;

